import { Component, Input, ContentChildren, QueryList } from '@angular/core'

import { CreditCardProps, creditCardStyles } from '@kite_aerolab/shared/components';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'kite-credit-card',
  templateUrl: './credit-card.component.html'
})
export class CreditCardComponent {

  @ContentChildren(MenuComponent) menuItems: QueryList<MenuComponent>;

  /**
   * CSS del componente
   */
   @Input() css: CreditCardProps['css'];

  /**
   * Title
   */
  @Input() title: CreditCardProps['title'];

  /**
   * SubTitle
   */
  @Input() subtitle: CreditCardProps['subtitle'];

  /**
   * Description
   */
  @Input() description: CreditCardProps['description'];

  /**
   * Icon
   */
  @Input() icon: CreditCardProps['icon'] = 'mastercard';

   /**
   * Variant
   */
  @Input() variant: CreditCardProps['variant'] = 'black';

  /**
   * Size
   */
  @Input() size: CreditCardProps['size'] = 'md';

  public get creditCardStyles(): string[] {
    return [
      creditCardStyles({
        css: this.css,
        size: this.size,
        variant: this.variant,
      }).className,
    ];
  }
}